export const enumList = {
  rateEnum: [
    // 税率
    { value: 1, label: '1%' },
    { value: 2, label: '3%' },
    { value: 3, label: '6%' },
  ],
  financeCType: [
    // 财务类型
    { value: 1, label: '作废收款' },
    { value: 2, label: '作废退款' },
    { value: 3, label: '作废预存' },
  ],
  balanceType: [
    // 余额类型
    { value: 1, label: '账户余额' },
    { value: 2, label: '预存余额' },
  ],
  invoiceFeeType: [
    // 发票费用类型
    { value: 1, label: '资产' },
    { value: 2, label: '租赁' },
  ],
  permissionFluctuantType: [
    // 权限变更类型
    { value: 1, label: '发放卡片' },
    { value: 2, label: '发放二维码' },
    { value: 3, label: '人工修改权限' },
    { value: 4, label: '系统修改权限' },
    { value: 5, label: '注销卡片' },
    { value: 6, label: '注销二维码' },
  ],
  specialTaxRateEnum: [
    // 数电专票税率
    { value: 1, label: '1%' },
    { value: 2, label: '3%' },
    { value: 3, label: '6%' },
  ],
  generalTaxRateEnum: [
    // 数电普票税率
    { value: 1, label: '1%' },
    { value: 2, label: '3%' },
  ],
  redStatus: [
    // 冲红状态
    { value: 0, label: '未冲红' },
    { value: 1, label: '冲红中' },
    { value: 2, label: '已冲红' },
  ],
  invoiceStatus: [
    // 开票状态
    { value: 0, label: '未开票' },
    { value: 1, label: '开票中' },
    { value: 2, label: '开票成功' },
    { value: 3, label: '开票失败' },
    { value: 4, label: '红字发票确认单申请中' },
    { value: 5, label: '红字发票确认单审核中' },
  ],
  hasTaxArr: [
    { value: 1, label: '含税' },
    { value: 0, label: '不含税' },
  ],
  invoiceIssueKindCode: [
    // 发票开具种类
    { value: 82, label: '增值税普通发票' },
    { value: 81, label: '增值税专用发票' },
  ],
  operationSuggestionsType: [
    // 操作建议类型
    { value: 0, label: '无需认证' },
    { value: 1, label: '需扫码认证' },
    { value: 2, label: '需扫码或短信认证' },
    { value: 3, label: '需短信认证' },
  ],
  carFluctuantType: [
    // 车辆变更类型
    { value: 1, label: '新增车辆' },
    { value: 2, label: '编辑车辆' },
    { value: 4, label: '删除车辆' },
    { value: 3, label: '设置收费标准' },
  ],
  parkingSpaceFluctuantType: [
    // 车位变更类型
    { value: 1, label: '新增车位' },
    { value: 2, label: '编辑车位' },
    { value: 5, label: '删除车位' },
    { value: 4, label: '财务交割' },
    { value: 3, label: '设置收费标准' },
  ],
  digitalLogType: [
    //数电账号登录身份类型
    { value: 1, label: '法定代表人' },
    { value: 2, label: '财务负责人' },
    { value: 3, label: '办税员' },
    { value: 4, label: '涉税服务人员' },
    { value: 5, label: '管理员' },
    { value: 7, label: '领票人' },
    { value: 9, label: '开票员' },
    { value: 99, label: '其他人员' },
  ],
  productNameEnum: [
    // 商品名称
    { value: 10, label: '短信额度' },
    { value: 9, label: '通话额度' },
    { value: 8, label: '商户续费额度' },
    { value: 12, label: '在线开票税号额度' },
  ],
  // 来访事由
  visitReason: [
    { value: 1, label: '亲友来访' },
    { value: 2, label: '商务来访' },
    { value: 3, label: '快递/外卖' },
    { value: 4, label: '其他' },
  ],
  unpaidSettingEnum: [
    // 欠费时配置
    { value: 1, label: '默认选中欠费周期' },
    { value: 2, label: '默认选中欠费周期+1个付款周期' },
    { value: 3, label: '默认选中欠费周期+12个月' },
    { value: 0, label: '默认不选中' },
  ],
  finishPaySettingEnum: [
    // 不欠费时配置
    { value: 1, label: '默认选中1个付款周期' },
    { value: 2, label: '默认选中欠费周期+默认选中12个月' },
    { value: 0, label: '默认不选中' },
  ],
  limitFeeTypeEnum: [
    // 电梯/门禁限制类型
    { value: 1, label: '物业费' },
    { value: 2, label: '电梯费' },
    { value: 3, label: '物业+电梯费' },
    { value: 4, label: '不限制' },
  ],
  cycleTypeEnum: [
    // 预算周期
    { value: 1, label: '月度' },
    { value: 2, label: '季度' },
    { value: 3, label: '半年' },
    { value: 4, label: '年度' },
  ],
  doorTypeEnum: [
    // 门禁类型
    { value: 1, label: '大门' },
    { value: 2, label: '单元门' },
    { value: 3, label: '人行摆闸' },
  ],
  isExistImage: [
    // 是否上传图片
    { value: 0, label: '未上传' },
    { value: 1, label: '已上传' },
  ],
  complaintHandleType: [
    // 投诉操作类型
    { value: 1, label: '提交' },
    { value: 2, label: '指派' },
    { value: 3, label: '接单' },
    { value: 4, label: '跟进' },
    { value: 5, label: '完成' },
    { value: 6, label: '重启' },
    { value: 7, label: '撤销' },
  ],
  complaintStatus: [
    // 投诉状态
    { value: 1, label: '待受理' },
    { value: 2, label: '待接单' },
    { value: 3, label: '处理中' },
    { value: 4, label: '已完成' },
    { value: 5, label: '已撤销' },
  ],
  // 提现审核类型
  withdrawalState: [
    { label: '审核中', value: 1 },
    { label: '待发放', value: 2 },
    { label: '已到账', value: 3 },
    { label: '审核驳回', value: 4 },
  ],
  videoClassification: [
    // 视频分类
    { label: '新手教程', value: 1, icon: require('@/assets/image/videoTutorials/image_1.png') },
    { label: '收费篇', value: 2, icon: require('@/assets/image/videoTutorials/image_2.png') },
    { label: '企业管理篇', value: 3, icon: require('@/assets/image/videoTutorials/image_3.png') },
    { label: '项目管理篇', value: 4, icon: require('@/assets/image/videoTutorials/image_4.png') },
    { label: '招商租赁篇', value: 5, icon: require('@/assets/image/videoTutorials/image_5.png') },
    { label: '安防管理篇', value: 6, icon: require('@/assets/image/videoTutorials/image_6.png') },
  ],
  timeArray: [
    { label: '上午', value: 1 },
    { label: '下午', value: 2 },
  ],
  expenditureAttributes: [
    // 收费方向
    { label: '收入', value: 1 },
    { label: '支出', value: 2 },
  ],
  cellAuditIdentity: [
    // 提审人身份
    { value: 1, label: '业主' },
    { value: 2, label: '物业' },
    { value: 3, label: '其他' },
  ],
  showLocation: [
    // 协议展示端
    { value: 1, label: '小区帮帮' },
    { value: 2, label: '物业帮帮' },
    { value: 3, label: 'PC后台' },
  ],
  buildingRentUnit: [
    // 租金单位
    { value: 1, label: '元/平方米/天' },
    { value: 2, label: '元/天' },
    { value: 3, label: '元/月' },
  ],
  buildingRentPayCycle: [
    // 付款周期
    { value: 1, label: '月付' },
    { value: 2, label: '季付' },
    { value: 3, label: '半年付' },
    { value: 4, label: '年付' },
  ],
  followUpStatus: [
    // 跟进状态
    { value: 1, label: '待指派' },
    { value: 2, label: '跟进中' },
    { value: 3, label: '已成交' },
    { value: 4, label: '已流失' },
  ],
  reminderMethod: [
    // 提醒方式
    { value: 1, label: '系统通知' },
    { value: 2, label: '微信推送' },
    // { value: 3, label: '短信通知' },
    // { value: 4, label: '电话通知' },
  ],
  calculationMethod: [
    // 欠费天数计算方式
    { value: 1, label: '应收日期' },
    { value: 2, label: '计费开始日期' },
    { value: 3, label: '计费结束日期（如果没有计费结束日期，将使用计费开始日期计算）' },
  ],
  arrearsMethod: [
    // 欠费金额计算方式
    { value: 1, label: '使用账单应收金额计算' },
    { value: 2, label: '使用账单应收金额-已收金额计算' },
  ],
  assetScope: [
    // 资产范围
    { value: 1, label: '全部' },
    { value: 2, label: '房屋-未售' },
    { value: 3, label: '房屋-已售' },
    { value: 4, label: '房屋-交房' },
    { value: 5, label: '房屋-入住' },
    { value: 6, label: '房屋-出租' },
    { value: 7, label: '房屋-空置' },
    { value: 8, label: '车位-已售' },
    { value: 9, label: '车位-出租' },
    { value: 10, label: '车位-空闲' },
    { value: 11, label: '车位-禁用' },
    { value: 12, label: '车位-自用' },
  ],
  meterBillingStatus: [
    // 抄表订单生成状态
    { value: 1, label: '生成中' },
    { value: 2, label: '生成失败' },
    { value: 3, label: '待复核' },
    { value: 4, label: '已复核' },
  ],
  meterCategory: [
    // 仪表类型
    { value: 1, label: '水表' },
    { value: 2, label: '电表' },
    { value: 3, label: '燃气表' },
  ],
  meterType: [
    // 仪表属性
    { value: 1, label: '总表' },
    { value: 2, label: '公摊表' },
    { value: 3, label: '户内表' },
  ],
  contractType: [
    // 签约渠道
    { value: 1, label: '银行卡' },
    { value: 2, label: '支付宝' },
    { value: 3, label: '微信' },
  ],
  discountAllowArrearage: [
    // 缴纳科目欠费时是否可参与优惠
    { value: 0, label: '不可参与优惠' },
    { value: 1, label: '可参与优惠' },
  ],
  discountDateType: [
    // 减免月份生效日期
    { value: 1, label: '本次缴费的应收日期' },
    { value: 2, label: '欠费的应收月份' },
  ],
  discountType: [
    // 优惠类型
    { value: 1, label: '减免月份' },
    { value: 2, label: '折扣' },
    { value: 3, label: '预存赠送' },
  ],
  reviewState: [
    // 复核状态
    { value: 0, label: '未复核' },
    { value: 1, label: '已复核' },
  ],
  signatureStatus: [
    // 短信签名状态
    { value: 1, label: '生效中' },
    { value: 2, label: '即将过期' },
    { value: 3, label: '已过期' },
  ],
  smsApplyType: [
    // 短信签名申请状态
    { value: 1, label: '申请中' },
    { value: 2, label: '已通过' },
    { value: 3, label: '未通过' },
  ],
  paymentReminderType: [
    // 催费费用类型
    { value: 1, label: '费用到期提醒' },
    { value: 2, label: '欠费催费提醒' },
  ],
  includePostponeType: [
    // 包含挂账
    { value: 0, label: '不包含' },
    { value: 1, label: '包含' },
  ],
  standardOperateType: [
    // 标准操作类型
    { value: 1, label: '新增' },
    { value: 2, label: '编辑' },
    { value: 3, label: '撤销' },
  ],
  additionalTypeEnum: [
    { value: 1, label: '面积*单价' },
    { value: 2, label: '用量*单价' },
    { value: 3, label: '固定金额' },
  ],
  formulaEnum: [
    { value: 1, label: '面积*计费周期*单价' },
    { value: 3, label: '每付款周期固定费用' },
  ],
  formulaEnumCustom: [
    { value: 1, label: '面积*计费周期*单价' },
    { value: 2, label: '人口数量*计费周期*单价' },
    { value: 3, label: '每付款周期固定费用' },
  ],
  aperiodicityEnum: [
    { value: 4, label: '面积*单价' },
    { value: 5, label: '一次性固定费用' },
  ],
  buildingState: [
    // 合同房屋状态
    { value: 1, label: '正常' },
    { value: 2, label: '续租' },
    { value: 3, label: '退租' },
    { value: 4, label: '转租' },
  ],
  bindSourceEnum: [
    // 费用绑定来源
    { value: 1, label: '由楼栋绑定' },
    { value: 2, label: '由单元绑定' },
    { value: 3, label: '由楼层绑定' },
    { value: 4, label: '由房屋绑定' },
    { value: 5, label: '由车场绑定' },
    { value: 6, label: '由车位绑定' },
  ],
  orderStatusEnum: [
    // 合同收款状态
    { value: 0, label: '未缴清', text: '未收款' },
    { value: 1, label: '已缴清', text: '已收款' },
  ],
  contractOperateType: [
    // 合同操作类型
    { value: 1, label: '新签' },
    { value: 2, label: '续租' },
    { value: 3, label: '转租' },
    { value: 4, label: '退租' },
  ],
  billingCycleEnum: [
    // 账单周期
    { value: 1, label: '按天计费' },
    { value: 2, label: '按月计费' },
    { value: 4, label: '按年计费' },
  ],
  paymentCycleEnum: [
    // 付款周期
    { value: 1, label: '月付' },
    { value: 3, label: '季付' },
    { value: 6, label: '半年付' },
    { value: 12, label: '年付' },
  ],
  paymentTypeEnum: [
    // 账单类型
    { value: 1, label: '预付', desc: '使用计费开始月份作为账单应收月份' },
    { value: 2, label: '提前1月预付', desc: '使用计费开始月份的上一月作为账单应收月份' },
    { value: 3, label: '后付', desc: '使用计费结束月份作为账单应收月份' },
    { value: 4, label: '延后1月后付', desc: '使用计费结束月份的下一月作为账单应收月份' },
  ],

  feeFormulaEnum: [
    // 计费公式
    { value: 1, label: '面积*计费周期*单价' },
    { value: 2, label: '人口数量*计费周期*单价' },
    { value: 3, label: '每付款周期固定费用' },
  ],
  costAttributeEnum: [
    // 费用属性
    { value: 0, label: '现业主欠费' },
    { value: 1, label: '交割欠费' },
  ],
  deviceStateEnum: [
    // 设备状态
    { value: 1, label: '启用' },
    { value: 2, label: '停用' },
    { value: 3, label: '报废' },
  ],
  // 巡检计划类型
  inspectionPlanType: [
    { value: 1, label: '半月' },
    { value: 2, label: '月度' },
    { value: 3, label: '季度' },
    { value: 4, label: '半年' },
    { value: 5, label: '年度' },
  ],
  // 模板分类
  templateTypeEnum: [
    { value: 1, label: '巡检' },
    { value: 2, label: '维保' },
  ],
  // 车场类型
  isParentEnum: [
    { value: 0, label: '小车场' },
    { value: 1, label: '大车场' },
  ],
  // 付费类型
  vehiclePayType: [
    { value: 1, label: '临时车', text: '设置免费' },
    { value: 2, label: '月租车', text: '取消月租' },
    { value: 3, label: '免费车', text: '取消免费' },
  ],
  //记录类型
  RecordType: [
    { value: 1, label: '入场记录' },
    { value: 2, label: '出场记录' },
    { value: 5, label: '人工记录入场' },
    { value: 6, label: '人工记录出场' },
    { value: 3, label: '月租车转临时车' },
    { value: 4, label: '免费车转临时车' },
  ],
  //开闸方式
  GateOpeningMethod: [
    { value: 1, label: '自动开闸' },
    { value: 2, label: '远程开闸' },
    { value: 3, label: '未成功开闸' },
  ],
  operationConfigEnum: [
    // 操作类型
    { value: 0, label: '未知' },
    { value: 1, label: '查询' },
    { value: 2, label: '新增' },
    { value: 3, label: '修改' },
    { value: 4, label: '删除' },
    { value: 5, label: '导入' },
    { value: 6, label: '导出' },
    { value: 7, label: '登录' },
    { value: 8, label: '登出' },
    { value: 9, label: '授权' },
    { value: 10, label: '审批' },
    { value: 11, label: '支付' },
  ],
  paymentStatus: [
    // 流水账单状态
    { value: 1, label: '待支付' },
    { value: 2, label: '支付中' },
    { value: 3, label: '已支付' },
    { value: 4, label: '支付失败' },
    { value: 5, label: '已撤销' },
    { value: 6, label: '支付异常' },
    { value: 7, label: '退款中' },
    { value: 8, label: '退款结束' },
    { value: 9, label: '已作废' },
  ],
  orderStatus: [
    // 明细账单状态
    { value: 1, label: '"待支付' },
    { value: 2, label: '已支付' },
    { value: 3, label: '已完成' },
    { value: 4, label: '已退款' },
    { value: 5, label: '已取消' },
    { value: 6, label: '已作废' },
  ],
  projectTypeArr: [
    // 项目类型
    { value: 1, label: '住宅项目' },
    { value: 2, label: '商业项目' },
    { value: 3, label: '工业项目' },
    { value: 4, label: '特种项目' },
    { value: 5, label: '公建项目' },
    { value: 7, label: '学校项目' },
    { value: 6, label: '其他项目' },
  ],
  changeTypeArr: [
    // 变动类型
    { value: 1, label: '发卡' },
    // { value: 2, label: '延期' },
    { value: 3, label: '注销' },
    // { value: 4, label: '解绑' },
  ],
  accessType: [
    // 门禁开门方式
    { value: 1, label: 'IC卡' },
    { value: 2, label: '二维码' },
    { value: 3, label: '远程' },
    { value: 4, label: '人脸识别' },
  ],
  rulesType: [
    //项目管理通行规则
    { value: 1, label: '物业费' },
    { value: 2, label: '电梯费' },
    { value: 3, label: '物业费和电梯费' },
    { value: 4, label: '不限制' },
  ],
  borrowStatusArr: [
    // 借用状态
    { value: 0, label: '未发放' },
    { value: 3, label: '已发放' },
    { value: 4, label: '已归还' },
  ],
  renovationContentArr: [
    // 装修内容
    { value: 1, label: '墙体改造' },
    { value: 2, label: '动火作业' },
    { value: 3, label: '高空作业' },
    { value: 4, label: '其他' },
  ],
  renovationType: [
    // 装修类型
    { value: 1, label: '新房装修' },
    { value: 2, label: '老房改造' },
  ],
  bindStatus: [
    // 绑定状态
    { value: '', label: '全部' },
    { value: 1, label: '绑定中' },
    { value: 2, label: '解绑' },
  ],
  decorationStatus: [
    // 装修状态
    { value: 1, label: '未开始' },
    { value: 2, label: '装修中' },
    { value: 3, label: '已延期' },
    { value: 4, label: '已完成' },
  ],
  contractState: [
    // 合同状态
    { value: 1, label: '未生效' },
    { value: 2, label: '生效中' },
    { value: 3, label: '已过期' },
  ],
  contractStateList: [
    // 人事合同状态
    { value: 1, label: '未生效' },
    { value: 2, label: '正常' },
    { value: 3, label: '已终止' },
  ],
  contentSourceType: [
    // 内容发布来源
    { value: 0, label: '街道发布' },
    { value: 1, label: '物业公司发布' },
    { value: 2, label: '业主发布' },
  ],
  votAuditArr: [
    // 投票审核状态
    { value: 1, label: '待审核' },
    { value: 2, label: '审核通过' },
    { value: 3, label: '审核拒绝' },
  ],
  deviceSystemEnum: [
    // 设备系统
    { value: 1, label: '电气设备' },
    { value: 2, label: '电梯设备' },
    { value: 3, label: '空调设备' },
    { value: 4, label: '给排水设备' },
    { value: 5, label: '消防设备' },
    // { value: 6, label: '弱电系统' },
    { value: 9, label: '公共安全设备' },
    { value: 10, label: '供暖设备' },
    { value: 11, label: '通风设备' },
    { value: 8, label: '其他' },
  ],
  brandTypeArr: [
    // 车牌类型
    { value: 1, label: '蓝色', color: '蓝牌白字' },
    { value: 2, label: '黄色', color: '黄牌黑字' },
    { value: 3, label: '黑色', color: '黑牌白字' },
    { value: 4, label: '绿色', color: '绿牌黑字' },
    { value: 5, label: '黄绿色', color: '黄绿牌黑字' },
    { value: 6, label: '白色', color: '白牌黑字' },
  ],
  workEarlyType: [
    // 考勤班次打卡最早时间段
    { value: 0, label: '不限制提前打卡时间', time: 0 },
    { value: 1, label: '最早提前30分钟打卡', time: 30 },
    { value: 2, label: '最早提前1小时打卡', time: 60 },
    { value: 3, label: '最早提前1小时30分钟打卡', time: 90 },
    { value: 4, label: '最早提前2小时打卡', time: 120 },
    { value: 5, label: '最早提前2小时30分钟打卡', time: 150 },
    { value: 6, label: '最早提前3小时打卡', time: 180 },
  ],
  workLatestType: [
    // 考勤班次打卡最晚时间段
    { value: 0, label: '不限制延后打卡时间', time: 0 },
    { value: 1, label: '最晚延后30分钟打卡', time: 30 },
    { value: 2, label: '最晚延后1小时打卡', time: 60 },
    { value: 3, label: '最晚延后1小时30分钟打卡', time: 90 },
    { value: 4, label: '最晚延后2小时打卡', time: 120 },
    { value: 5, label: '最晚延后2小时30分钟打卡', time: 150 },
    { value: 6, label: '最晚延后3小时打卡', time: 180 },
  ],
  refundAuditStateArr: [
    // 退款审批状态
    { value: 0, label: '不审核' },
    { value: 1, label: '待审核' },
    { value: 2, label: '审核中' },
    { value: 3, label: '审核通过' },
    { value: 4, label: '驳回' },
    { value: 5, label: '已退款' },
    { value: 6, label: '已撤销' },
  ],
  jobEnumArr: [
    // 职位枚举
    { value: 0, label: '董事长' },
    { value: 1, label: '总经理' },
    { value: 2, label: '副总经理' },
    { value: 3, label: '人事' },
    { value: 4, label: '行政' },
    { value: 5, label: '财务' },
    { value: 6, label: '出纳' },
    { value: 7, label: '项目经理' },
    { value: 8, label: '客服' },
    { value: 9, label: '保洁' },
    { value: 10, label: '保安' },
    { value: 11, label: '绿化' },
    { value: 12, label: '维修' },
    { value: 13, label: '消控' },
    { value: 14, label: '采购' },
    { value: 15, label: '宿管' },
    { value: 16, label: '物业经理' },
    { value: 17, label: '营销经理' },
    { value: 9999, label: '无职位' },
  ],
  orderSourceArr: [
    // 支付渠道
    { value: 1, label: '后台' },
    { value: 2, label: '物业端' },
    { value: 3, label: '业主端' },
    { value: 4, label: '预扣款' },
  ],
  invoiceStateArr: [
    // 开票状态
    { value: 0, label: '未开发票' },
    { value: 1, label: '已开发票' },
    { value: 2, label: '已预开发票' },
    { value: 3, label: '部分开票' },
  ],
  orderCreateType: [
    // 订单来源
    { value: 1, label: '系统创建' },
    { value: 2, label: '物业管理员' },
    { value: 3, label: '业主' },
    { value: 4, label: '物业管理员冲账' },
  ],
  preferentialAuditState: [
    // 优惠申请审核状态
    {
      value: 0,
      label: '不审核',
    },
    {
      value: 1,
      label: '待审核',
    },
    {
      value: 2,
      label: '审核中',
    },
    {
      value: 3,
      label: '通过',
    },
    {
      value: 4,
      label: '驳回',
    },
    {
      value: 5,
      label: '取消优惠',
    },
  ],
  inspectNoticeType: [
    // 巡检提醒设置
    {
      value: 0,
      label: '不提醒',
    },
    {
      value: 1,
      label: '提醒',
    },
  ],
  bannerPositionList: [
    // banner展示位置
    {
      value: 3,
      label: '小区帮帮首页',
    },
    {
      value: 4,
      label: '小区帮帮商户页',
    },
  ],
  contentTypeStreetArr: [
    { value: 2, label: '社区公告' },
    { value: 3, label: '问卷调查' },
    { value: 6, label: '党建宣传' },
  ],
  contentTypeArr: [
    { value: 1, label: '物业风采' },
    { value: 2, label: '社区公告' },
    { value: 3, label: '问卷调查' },
    { value: 4, label: '公司通知' },
  ],
  indoorRepairReportEnum: [
    { value: 3, label: '管道疏通', describe: '马桶疏通、地漏疏通、洗手池疏通等问题' },
    { value: 4, label: '水路报修', describe: '马桶、地漏、水龙头、暖气等问题' },
    { value: 5, label: '电路报修', describe: '灯具、插座、电闸、电线等问题' },
    { value: 6, label: '房屋主体报修', describe: '门、窗、墙面、地面等问题' },
    { value: 7, label: '电器报修', describe: '空调、燃气、热水器、冰箱等问题' },
    { value: 8, label: '其他', describe: '其他问题' },
  ],
  publicAreaRepairReportEnum: [
    { value: 11, label: '电路报修', describe: '照明等问题' },
    { value: 12, label: '水路报修', describe: '水管、消防栓、积水等问题' },
    { value: 13, label: '土建报修', describe: '墙体、墙面、路面等问题' },
    { value: 15, label: '公共卫生', describe: '公共卫生等问题' },
    { value: 14, label: '其他', describe: '其他问题' },
  ],
  // 设备设施报修
  facilityRepairReportEnum: [
    { value: 9, label: '电梯报修', describe: '电梯问题' },
    { value: 10, label: '设施设备报修', describe: '监控、车闸、门禁、景观、健身器材等问题' },
  ],
  serviceExpireState: [
    // 租户管理-会员到期状态
    { value: 0, label: '已过期' },
    { value: 1, label: '即将过期' },
    { value: 2, label: '未过期' },
  ],
  pcDeploymentTypeArr: [
    // 后台域名配置类型
    { value: 1, label: 'sass' },
    { value: 2, label: '二级域名' },
  ],
  appDeploymentTypeArr: [
    // 客户端配置类型
    { value: 1, label: 'saas' },
    { value: 2, label: '独立部署' },
  ],
  organizationTypeArr: [
    // 租户类型
    { value: 0, label: '街道' },
    { value: 1, label: '物业' },
    { value: 2, label: '物业科' },
  ],
  applicationTypeArr: [
    // 客户端类型
    { value: 101, label: '业主端' },
    { value: 110, label: '物业端' },
  ],
  weekDays: [
    { value: '1', label: '周一' },
    { value: '2', label: '周二' },
    { value: '3', label: '周三' },
    { value: '4', label: '周四' },
    { value: '5', label: '周五' },
    { value: '6', label: '周六' },
    { value: '7', label: '周日' },
  ],
  ruleMethodArr: [
    // 考勤方式
    { value: 1, label: '地点打卡' },
    { value: 2, label: 'wifi打卡' },
  ],
  completeStateArr: [
    // 保洁统计完成情况
    { value: 0, label: '未完成' },
    { value: 1, label: '已完成' },
  ],
  inspectedResultArr: [
    // 保洁记录检查结果
    { value: 0, label: '不合格' },
    { value: 1, label: '合格' },
  ],
  isInspectedArr: [
    // 保洁记录是否抽检
    { value: 0, label: '未抽检' },
    { value: 1, label: '已抽检' },
  ],
  cleaningRouteStateArr: [
    // 保洁路线启用状态
    { value: 0, label: '停用' },
    { value: 1, label: '启用' },
  ],
  cleaningClockTypeArr: [
    // 保洁管理-打卡地点类型
    { value: 1, label: '项目' },
    { value: 2, label: '楼栋' },
    { value: 3, label: '单元' },
    { value: 4, label: '楼层' },
    { value: 5, label: '其他' },
  ],
  approvalAuthorityArr: [
    // 是否具有审批权限
    { value: 0, label: '否' },
    { value: 1, label: '是' },
  ],
  materialIsDistributionArr: [
    // 发放状态
    { value: 0, label: '未发放' },
    { value: 1, label: '已发放' },
  ],
  approveModeArr: [
    // 审批方式
    { value: 1, label: '会签' },
    { value: 2, label: '或签' },
  ],
  timeUnitArr: [
    // 最小请假单位
    { value: 1, label: '小时' },
    { value: 2, label: '天' },
  ],
  travelTypeArr: [
    // 单程往返类型
    { value: 1, label: '单程' },
    { value: 2, label: '往返' },
  ],
  operateTypeArr: [
    // 操作类型
    { value: 1, label: '提交待审批' },
    { value: 2, label: '驳回' },
    { value: 3, label: '审批通过' },
    { value: 4, label: '完成物资发放' },
    { value: 5, label: '取消优惠' },
    { value: 6, label: '退款' },
    { value: 7, label: '销假' },
    { value: 8, label: '撤销' },
  ],
  applyStateArr: [
    // 审批状态
    { value: 1, label: '提交待审批' },
    { value: 2, label: '审批中' },
    { value: 3, label: '驳回' },
    { value: 4, label: '审批通过' },
    { value: 5, label: '完成物资发放' },
    { value: 6, label: '取消优惠申请' },
    { value: 7, label: '已退款' },
    { value: 11, label: '销假中' },
    { value: 12, label: '已撤销' },
    { value: 13, label: '拒绝销假' },
  ],
  approveLevelArr: [
    // 审批层级
    { value: 1, label: '直接主管' },
    { value: 2, label: '上一级部门' },
    { value: 3, label: '上两级部门' },
  ],
  approveTypeArr: [
    // 审批类型
    { value: 1, label: '报销' },
    { value: 2, label: '请假' },
    { value: 3, label: '出差' },
    { value: 4, label: '物资领用' },
    { value: 5, label: '优惠' },
    { value: 6, label: '退款' },
    { value: 7, label: '住户认证' },
    { value: 8, label: '用章审批' },
    { value: 9, label: '装修申请' },
    // { value: 10, label: '物资借用' },
    { value: 11, label: '采购' },
    { value: 12, label: '补卡' },
    { value: 13, label: '合同优惠' },
    { value: 14, label: '合同退款' },
    { value: 15, label: '财务作废' },
  ],
  approveUserTypeArr: [
    // 审批人模式
    { value: 1, label: '指定人员审批' },
    { value: 2, label: '直接主管审批' },
    { value: 3, label: '上一级部门主管审批' },
    { value: 4, label: '上二级部门主管审批' },
  ],
  isSendCopyArr: [
    // 是否抄送
    { value: 1, label: '是' },
    { value: 2, label: '否' },
  ],
  rangeTypeArr: [
    // 适用范围
    { value: 1, label: '全部' },
    { value: 2, label: '指定员工' },
  ],
  terminalArr: [
    // 终端类型
    { value: 1, label: '微信' },
    { value: 2, label: 'APP' },
    { value: 3, label: 'PC端' },
  ],
  operationResultsArr: [
    // 操作结果类型
    { value: 0, label: '请求中' },
    { value: 1, label: '成功' },
    { value: 2, label: '失败' },
  ],
  operationTypeArr: [
    // 操作类型
    { value: 1, label: '查看列表' },
    { value: 2, label: '查看详情' },
    { value: 3, label: '新增' },
    { value: 4, label: '更新' },
    { value: 5, label: '删除' },
    { value: 6, label: '登录' },
    { value: 7, label: '忘记密码' },
    { value: 8, label: '退出登录' },
  ],

  incomeDirection: [
    // 交易类型/收入方向
    { value: 1, label: '预存' },
    { value: 2, label: '费用' },
    { value: 3, label: '作废' },
  ],
  changeType: [
    // 变动类型
    { value: 1, label: '退款转存' },
    { value: 2, label: '支付扣减' },
  ],
  payWay: [
    // 支付渠道,退款方式,收款方式
    { value: 1, label: '支付宝' },
    { value: 2, label: '微信', otherEnum: 7 },
    { value: 5, label: '现金' },
    { value: 6, label: 'POS机' },
    { value: 8, label: '预存抵扣' },
    { value: 9, label: '账户余额' },
    // { value: 10, label: '组合收款' },
    { value: 11, label: '对公转账' },
    { value: 12, label: '银行代扣' },
  ],
  paySource: [
    // 收款渠道
    { value: 1, label: 'PC后台' },
    { value: 2, label: '物业帮帮' },
    { value: 3, label: '小区帮帮' },
  ],
  ownershipRelation: [
    // 住户角色
    { value: 1, label: '业主', color: '#00B42A' },
    { value: 2, label: '租户', color: '#FF9002' },
    { value: 3, label: '家属', color: '#31A8FF' },
  ],
  administrativePost: [
    // 住户身份
    { value: 1, label: '普通用户' },
    { value: 2, label: '楼栋长' },
    { value: 3, label: '单元长' },
  ],
  buildingType: [
    // 房屋属性
    { value: 1, label: '住宅' },
    { value: 2, label: '商铺' },
    { value: 8, label: '档口' },
    { value: 6, label: '办公' },
    { value: 9, label: '工位' },
    { value: 3, label: '宿舍' },
    { value: 4, label: '仓库' },
    { value: 10, label: '酒店' },
    { value: 7, label: '公寓' },
    { value: 11, label: '厂房' },
    { value: 12, label: '学生宿舍' },
    { value: 13, label: '冷库' },
    { value: 5, label: '其他' },
  ],
  isOccupancy: [
    // 房屋状态
    { value: 0, label: '未入住' },
    { value: 1, label: '已入住' },
  ],
  roomUsageState: [
    // 房屋状态
    { value: 1, label: '未售' },
    { value: 2, label: '已售' },
    { value: 3, label: '交房' },
    { value: 4, label: '入住' },
    { value: 5, label: '出租' },
    { value: 6, label: '空置' },
  ],
  spaceState: [
    // 车位状态
    { value: 1, label: '已售' },
    { value: 2, label: '出租' },
    { value: 3, label: '空闲' },
    { value: 4, label: '禁用' },
    { value: 5, label: '自用' },
  ],
  parkSpaceType: [
    { value: 1, label: '小车位' },
    { value: 2, label: '中车位' },
    { value: 3, label: '大车位' },
    { value: 4, label: '人防车位' },
  ],
  carType: [
    // 车辆类型
    { value: 1, label: '小汽车' },
    { value: 2, label: '客车' },
    { value: 3, label: '货车' },
    { value: 4, label: '电动车' },
    { value: 5, label: '三轮车' },
    { value: 6, label: '摩托车' },
  ],
  paymentModal: [
    { value: 1, label: '物业费模板' },
    { value: 2, label: '车位租赁费模板' },
    { value: 3, label: '临时停车费模板' },
    { value: 4, label: '电梯费模板' },
    { value: 6, label: '阶梯水费模板' },
    { value: 7, label: '二次供水费模板' },
    { value: 8, label: '电费模板' },
    { value: 9, label: '燃气费模板' },
    { value: 10, label: '保证金模板' },
    { value: 11, label: '自定义模板' },
  ],
  refundState: [
    // 审批结果, 退款状态
    { value: 1, label: '待审批' },
    { value: 2, label: '待退款' },
    { value: 3, label: '已完成' },
    { value: 4, label: '驳回申请' },
  ],
  refundStateTwo: [
    // 退款状态
    { value: 1, label: '申请退款' },
    { value: 2, label: '同意退款' },
    { value: 3, label: '拒绝退款' },
  ],
  flowRefundStateArr: [
    // 退款状态
    { value: 0, label: '待退款' },
    { value: 1, label: '已退款' },
  ],
  carState: [
    // 车辆状态
    { value: 0, label: '无车位' },
    { value: 1, label: '正常' },
    { value: 2, label: '过期' },
  ],
  chargeMode: [
    { value: 1, label: '按天' },
    { value: 2, label: '按月（31天）' },
    { value: 3, label: '按季度' },
    { value: 4, label: '按房屋人口' },
    { value: 5, label: '按房屋面积' },
    { value: 6, label: '按房屋' },
  ],
  priceBasis: [
    { value: 1, label: '按面积' },
    { value: 2, label: '按车位固定收费' },
  ],
  chargeType: [
    { value: 1, label: '按月收取' },
    { value: 2, label: '按季度收取' },
    { value: 3, label: '按年收取' },
    { value: 4, label: '按房屋人口' },
    { value: 5, label: '按房屋面积' },
    { value: 6, label: '按房屋' },
  ],
  shiftCycle: [
    { value: 1, label: '一周' },
    { value: 2, label: '二周' },
    { value: 3, label: '三周' },
    { value: 4, label: '四周' },
  ],
  shiftRules: [
    { value: 1, label: '向下轮班' },
    { value: 2, label: '向上轮班' },
  ],
  worksheetType: [
    // 工单类型
    { value: 1, label: '户内报修' },
    { value: 2, label: '公区报修' },
    // { value: 3, label: '建议' },
    // { value: 4, label: '投诉' },
    { value: 5, label: '设备设施' },
  ],
  distributeType: [
    { value: 1, label: '抢单' },
    { value: 2, label: '指派' },
    { value: 3, label: '轮训' },
  ],
  urgentType: [
    // 报修情况
    { value: 1, label: '紧急' },
    { value: 2, label: '重要' },
    { value: 3, label: '一般' },
  ],
  distributeSource: [
    // 工单来源
    { value: 0, label: '其他' },
    { value: 1, label: '业主端' },
    { value: 2, label: '物业端' },
    { value: 3, label: '电话报修' },
    { value: 4, label: '智能客服' },
  ],
  distributeState: [
    // 工单状态
    { value: 1, label: '提交' },
    { value: 2, label: '待派单' },
    { value: 3, label: '待接单' },
    { value: 7, label: '待签到' },
    { value: 4, label: '待完成' },
    { value: 5, label: '已完成' },
    { value: 6, label: '已关闭' },
  ],
  templateTypes: [
    { value: 1, label: '收款收据' },
    { value: 2, label: '退款收据' },
  ],
  areaType: [
    { value: 1, label: '建筑面积' },
    { value: 2, label: '使用面积' },
    { value: 3, label: '公摊面积' },
  ],
  materialUnit: [
    // 出库数量单位
    { value: 1, label: '个' },
    { value: 5, label: '米' },
    { value: 7, label: '把' },
    { value: 8, label: '袋' },
    { value: 3, label: '瓶' },
    { value: 9, label: '包' },
    { value: 15, label: '盒' },
    { value: 4, label: '千克' },
    { value: 6, label: '平方米' },
    { value: 10, label: '条' },
    { value: 11, label: '卷' },
    { value: 12, label: '套' },
    { value: 13, label: '部' },
    { value: 14, label: '台' },
    { value: 2, label: '箱' },
    { value: 16, label: '副' },
  ],
  stockState: [
    // 库存状态
    { value: 1, label: '全部' },
    { value: 2, label: '充足' },
    { value: 3, label: '紧缺' },
  ],
  loginAllowDevice: [
    // 登录权限
    { value: 1, label: '可以登录物业帮帮小程序和PC管理后台' },
    { value: 2, label: '只能登录物业帮帮小程序' },
    { value: 3, label: '只能登录PC管理后台' },
  ],
  attendanceState: [
    // 考勤状态
    { value: 0, label: '正常' },
    { value: 1, label: '上班迟到' },
    { value: 2, label: '上班未打卡' },
    { value: 3, label: '早退' },
    { value: 4, label: '下班未打卡' },
  ],
  handleType: [
    // 操作类型
    { value: 1, label: '提交' },
    { value: 2, label: '抢单' },
    { value: 3, label: '指派' },
    { value: 4, label: '到场签到' },
    { value: 5, label: '退单' },
    { value: 6, label: '结单' },
    { value: 7, label: '评价' },
    { value: 8, label: '接单' },
    { value: 9, label: '关闭' },
    { value: 10, label: '领料' },
    { value: 11, label: '返单' },
  ],
  orderStateList: [
    // 订单状态
    { value: 1, label: '待付款' },
    { value: 2, label: '等待服务' },
    { value: 3, label: '已取货' },
    { value: 4, label: '已完成' },
    { value: 5, label: '已取消' },
    { value: 6, label: '退款中' },
    { value: 7, label: '已退款' },
    { value: 10, label: '准备完成' },
    { value: 11, label: '开始外送' },
  ],
  operationType: [
    // 订单流转操作类型
    { value: 1, label: '提交' },
    { value: 2, label: '支付成功' },
    { value: 3, label: '客户取货' },
    { value: 4, label: '完成交易' },
    { value: 5, label: '提交取消' },
    { value: 6, label: '申请退款' },
    { value: 7, label: '商家同意退款' },
    { value: 8, label: '商家拒绝退款' },
    { value: 9, label: '评价' },
  ],
  processState: [
    // 处理意见
    { value: 1, label: '待处理' },
    { value: 2, label: '举报无效' },
    { value: 3, label: '举报属实' },
  ],
  tipType: [
    // 举报类型
    { value: 1, label: '违法违规' },
    { value: 2, label: '色情低俗' },
    { value: 3, label: '虚假信息' },
    { value: 4, label: '诈骗信息' },
    { value: 5, label: '售卖假货' },
    { value: 6, label: '其他' },
  ],
  contentType: [
    // 列表文章类型
    { value: 1, label: '社区互助' },
    { value: 2, label: '寻物启示' },
    { value: 3, label: '社区闲置' },
    { value: 4, label: '社区活动' },
    { value: 5, label: '社区招聘' },
    { value: 6, label: '社区资讯' },
  ],
  isFinishOpt: [
    // 文章状态
    { value: 0, label: '未解决' },
    { value: 1, label: '已解决' },
  ],
  residentAgeArr: [
    // 年龄标签
    { value: 1, label: '其他' },
    { value: 2, label: '老年人' },
    { value: 3, label: '婴幼儿' },
  ],
  cooperationStatus: [
    // 合作状态
    { value: 1, label: '待跟进' },
    { value: 2, label: '正在跟进' },
    { value: 3, label: '达成合作' },
    { value: 4, label: '未达成合作' },
  ],
  cooperationType: [
    // 合作类型
    { value: 1, label: '物业' },
    { value: 2, label: '街道' },
    { value: 3, label: '合伙人' },
    { value: 4, label: '经销商' },
    { value: 5, label: '代理商' },
  ],
  requestStateArr: [
    // 申领状态
    { value: 1, label: '待审批' },
    { value: 2, label: '待领用' },
    { value: 3, label: '已完结' },
    { value: 4, label: '驳回申请' },
    { value: 5, label: '查询已审批数据' },
  ],
  stockTypeList: [
    // 出入库类型
    { value: 1, label: '出库' },
    { value: 2, label: '入库' },
    { value: 3, label: '调拨出库' },
    { value: 4, label: '调拨入库' },
    { value: 5, label: '盘点入库' },
    { value: 6, label: '盘点出库' },
    { value: 7, label: '领用出库' },
    { value: 8, label: '采购入库' },
    { value: 9, label: '工单出库' },
    { value: 10, label: '工单退库' },
  ],
  auditStateList: [
    // 审核状态
    { value: 1, label: '正常' },
    { value: 2, label: '待审核' },
    { value: 3, label: '驳回' },
  ],
  auditState: [
    // 商品审核状态、审核状态、审核意见
    { value: 1, label: '待审核' },
    { value: 2, label: '通过' },
    { value: 3, label: '驳回' },
  ],
  auditStateTwo: [
    // 审核状态
    { value: 0, label: '待审核' },
    { value: 1, label: '通过' },
    { value: 2, label: '驳回' },
  ],
  serviceState: [
    // 商品状态
    { value: 1, label: '下架' },
    { value: 2, label: '上架' },
    { value: 3, label: '禁用' },
  ],
  disabledState: [
    // 商品禁用状态
    { value: 0, label: '禁用' },
    { value: 1, label: '正常' },
  ],
  orderTypeList: [
    // 订单类型
    { value: 1, label: '到店订单' },
    { value: 2, label: '上门订单' },
  ],
  communityState: [
    // 项目状态
    { value: 0, label: '驳回' },
    { value: 1, label: '正常' },
    { value: 2, label: '待审核' },
  ],
  isAppraiseArr: [
    // 是否评价
    { value: 0, label: '未评价' },
    { value: 1, label: '已评价' },
  ],
  isReturnVisitArr: [
    // 是否回访
    { value: 0, label: '未回访' },
    { value: 1, label: '已回访' },
  ],
  monitorProcessState: [
    // 报警处理状态
    { value: 0, label: '待处理' },
    { value: 1, label: '已完成' },
  ],
  monitorProcessResult: [
    // 报警处理结果
    { value: 0, label: '已解决' },
    { value: 1, label: '生成工单' },
    { value: 2, label: '误报' },
  ],
  workClockFieldPersonnelArr: [
    // 打卡类型
    { value: 0, label: '内勤打卡' },
    { value: 1, label: '外勤打卡' },
  ],
  workState: [
    // 上班状态
    { value: 1, label: '上班' },
    { value: 2, label: '休假' },
  ],
  residentType: [
    //住户管理-住户列表-新增-住户类型
    { value: 1, label: '个人' },
    { value: 2, label: '公司' },
  ],
  authenticationType: [
    //认证类型
    { value: 1, label: '住户认证' },
    { value: 2, label: '绑定资产' },
    { value: 3, label: '住户信息更新' },
  ],
  assetType: [
    //资产类型
    { value: 1, label: '房屋' },
    { value: 2, label: '车位' },
    { value: 3, label: '车辆' },
  ],
  sexType: [
    //性别
    { value: 1, label: '男' },
    { value: 2, label: '女' },
    { value: 3, label: '未知' },
  ],
  checkResult: [
    //抽检结果
    { value: 1, label: '合格' },
    { value: 2, label: '不合格' },
  ],
  cleaningEvaluation: [
    //保洁考评内容
    { value: 1, label: '保洁地点完成率：保洁地点应完成次数/实际完成次数，无应完成次数时默认为满分' },
    { value: 2, label: '保洁区域完成率：保洁区域完成次数/实际完成次数，无应完成次数时默认为满分。如为多人协同保洁区域，则共享应完成次数和已完成次数' },
    { value: 3, label: '抽检合格率：保洁抽检合格次数/抽检总次数，未抽检时默认为满分' },
    { value: 4, label: '住户综合评分：住户综合评分平均分/总分，无住户评分时默认为满分' },
    { value: 5, label: '服务态度评分：住户服务态度评分平均分/总分，无住户评分时默认为满分' },
    { value: 6, label: '服务效率评分：住户服务效率评分平均分/总分，无住户评分时默认为满分' },
    { value: 7, label: '服务质量评分：住户服务质量评分平均分/总分，无住户评分时默认为满分' },
  ],
  patrolEvaluation: [
    //巡更考评内容
    { value: 1, label: '巡更地点完成率：巡更地点应完成次数/实际完成次数，无应完成次数时默认为满分' },
    { value: 2, label: '巡更区域完成率：巡更区域完成次数/实际完成次数，无应完成次数时默认为满分。如为多人协同巡更区域，则共享应完成次数和已完成次数' },
  ],
  workOrderEvaluation: [
    //工单考评内容
    { value: 1, label: '工单完成率：收到工单派单数量/完成工单数量，未收到工单则默认为满分' },
    { value: 2, label: '工单综合评分：工单综合评分平均分/总分，无住户评分时默认为满分' },
    { value: 3, label: '服务态度评分：工单服务态度评分平均分/总分，无住户评分时默认为满分' },
    { value: 4, label: '服务效率评分：工单服务效率评分平均分/总分，无住户评分时默认为满分' },
    { value: 5, label: '服务质量评分：工单服务质量评分平均分/总分，无住户评分时默认为满分' },
  ],
  jobEnumArrCheck: [
    // 考评规则适用职位筛选枚举
    { value: 9, label: '保洁' },
    { value: 10, label: '保安' },
    { value: 12, label: '维修' },
  ],
  deviceStatus: [
    //监控-设备状态
    { value: 0, label: '离线' },
    { value: 1, label: '在线' },
  ],
  deviceType: [
    //监控-设备类别
    { value: 1, label: '摄像头' },
    { value: 2, label: 'nvr' },
  ],
  policeType: [
    //报警中心-设备类别
    { value: 1, label: '高空抛物' },
    { value: 2, label: '电梯监测' },
    { value: 3, label: '离岗检测' },
  ],
  alarmType: [
    //报警记录-报警类型
    { value: 1, label: '设备恢复' },
    { value: 2, label: '设备离线' },
  ],
  alerPoliceType: [
    //报警记录-设备类别
    { value: 1, label: '门禁' },
    { value: 2, label: '梯控' },
    { value: 3, label: '道闸' },
    { value: 4, label: '监控' },
  ],
  manufacturer: [
    //监控-厂家名称
    { value: 1, label: '海康' },
  ],
  manufacturerType: [
    //监控-厂家类型
    { value: 1, label: 'EHome' },
  ],
  storeType: [
    //商户类型
    { value: 1, label: '个人' },
    { value: 2, label: '商家' },
  ],
  getMoneyWay: [
    //收款方式
    { value: 1, label: '收款至微信商户号' },
    { value: 2, label: '收款至小区帮帮钱包' },
  ],
  auditType: [
    //审核类型
    { value: 1, label: '新增商品' },
    { value: 2, label: '编辑商品' },
  ],
  serviceCategoryType: [
    //服务类型
    { value: 1, label: '美食' },
    { value: 2, label: '商品' },
    { value: 3, label: '服务' },
  ],
  refundType: [
    //退款原因枚举
    { value: 1, label: '预约问题' },
    { value: 2, label: '商家未提供，少提供商品或服务' },
    { value: 3, label: '店铺/商品信息问题' },
    { value: 4, label: '还未消费，商家提前完成下单' },
    { value: 5, label: '买错了，重新下单' },
    { value: 6, label: '不想要了' },
    { value: 7, label: '更多原因' },
  ],
  ruleUseType: [
    //催缴规则使用状态
    { value: 1, label: '启用' },
    { value: 0, label: '停用' },
  ],
  expenseType: [
    //费用类型
    { value: 1, label: '合同费用' },
    { value: 2, label: '房屋费用' },
    { value: 3, label: '车位费用' },
  ],
  reminderMode: [
    //缴费提醒方式
    { value: 0, label: '电话' },
    { value: 1, label: '短信' },
    { value: 2, label: '电话、短信' },
  ],
  moneyBody: [
    //费用类型
    { value: 1, label: '房屋费用' },
    { value: 2, label: '车位费用' },
  ],
  taskType: [
    //通知类型
    { value: 1, label: '费用到期提醒' },
    { value: 2, label: '欠费催费提醒' },
  ],
  getMoneyType: [
    //通知方式
    { value: 1, label: '短信' },
    { value: 2, label: '电话' },
    { value: 3, label: '微信' },
  ],
  renovationStateType: [
    //装修的状态
    { value: 1, label: '提交待审批' },
    { value: 2, label: '审批中' },
    { value: 3, label: '驳回' },
    { value: 4, label: '装修中' },
    { value: 9, label: '待验收' },
    { value: 10, label: '验收通过' },
  ],

  renovationOperateType: [
    // 装修流程操作阶段
    { value: 1, label: '提交申请' },
    { value: 2, label: '缴纳费用' },
    { value: 3, label: '取消申请' },
    { value: 4, label: '审批通过' },
    { value: 5, label: '审批驳回' },
    { value: 6, label: '申请验收' },
    { value: 7, label: '验收通过' },
    { value: 8, label: '验收驳回' },
  ],
  operateTerminal: [
    //装修流程操作终端
    { value: 3, label: '物业帮帮' },
    { value: 4, label: '小区帮帮' },
    { value: 5, label: '物业帮帮后台' },
  ],
  payType: [
    { value: 1, label: '临时车' },
    { value: 2, label: '月租车' },
    { value: 3, label: '免费车' },
    { value: 4, label: '来访车' },
  ],
  AgreementTypeEnum: [
    { value: 1, label: '韦根协议' },
    { value: 2, label: 'MQTT协议' },
    { value: 3, label: 'EHome协议' },
  ],
  exportState: [
    //导入导出记录文件类型
    { value: 1, label: '房屋导入Excel数据' },
    { value: 2, label: '住户导入Excel数据' },
    { value: 3, label: '车位类型导入Excel数据' },
    { value: 4, label: '车场导入Excel数据' },
    { value: 5, label: '车位导入Excel数据' },
    { value: 6, label: '车辆导入Excel数据' },
    { value: 7, label: '物资导入Excel数据' },
    { value: 8, label: '物资库存导入Excel数据' },
    { value: 9, label: '巡更地点导入Excel数据' },
    { value: 10, label: '保洁地点导入Excel数据' },
    { value: 11, label: '房屋关联计费导入Excel数据' },
    { value: 12, label: '车位关联计费导入Excel数据' },
    { value: 13, label: '巡检项目包含设备Excel数据导入' },
    { value: 14, label: '设备系统导入Excel数据' },
    { value: 15, label: '设备导入Excel数据' },
    { value: 16, label: '巡更路线关联地点导入Excel数据' },
    { value: 17, label: 'usbKey导入Excel数据' },
    { value: 18, label: '车位数据导出' },
    { value: 19, label: '出差审批数据导出' },
    { value: 20, label: '请假审批数据导出' },
    { value: 21, label: '车辆数据导出' },
    { value: 22, label: '房屋数据导出' },
    { value: 23, label: '考勤记录数据导出' },
    { value: 24, label: '考勤统计数据导出' },
    { value: 25, label: '保洁记录数据导出' },
    { value: 26, label: '保洁统计数据导出' },
    { value: 27, label: '巡更统计数据导出' },
    { value: 28, label: '巡检记录数据导出' },
    { value: 29, label: '收款记录数据导出' },
    { value: 30, label: '房屋未缴数据导出' },
    { value: 31, label: '车位未缴数据导出' },
    { value: 32, label: '工单数据导出' },
    { value: 33, label: '收款记录导出' },
    { value: 34, label: '费用明细数据导出' },
    { value: 35, label: '房屋费用初始化导出' },
    { value: 36, label: '财务报表-年度报表-应收账单收款金额导出' },
    { value: 37, label: '财务报表-年度报表-应收账单优惠导出' },
    { value: 38, label: '财务报表-年度报表-应收账单未收导出' },
    { value: 39, label: '财务报表-年度报表-本年实际收款导出' },
    { value: 40, label: '应收报表数据导出' },
    { value: 41, label: '应收报表数据导出' },
    { value: 42, label: '应收报表数据导出' },
    { value: 43, label: '应收报表数据导出' },
    { value: 44, label: '应收报表数据导出' },
    { value: 45, label: '财务报表-应收报表-本段时间支付导出' },
    { value: 46, label: '财务报表-应收报表-历史预缴导出' },
    { value: 47, label: '财务报表-应收报表-历史预缴抵扣导出' },
    { value: 48, label: '财务报表-收款报表-当期缴费导出' },
    { value: 49, label: '财务报表-收款报表-陈欠清缴导出' },
    { value: 50, label: '财务报表-收款报表-预缴导出' },
    { value: 51, label: '财务报表-收款报表-预存导出' },
    { value: 52, label: '财务报表-收款报表-按收款科目、收款方式、收款渠道统计导出' },
    { value: 53, label: '欠费报表数据导出' },
    { value: 54, label: '欠费报表数据导出' },
    { value: 55, label: '财务报表-预存预缴报表-预缴导出' },
    { value: 56, label: '周期性适用车位记录导出' },
    { value: 57, label: '操作日志数据导出' },
    { value: 58, label: '政府监管:公司机构导出' },
    { value: 59, label: '政府监管:项目机构导出' },
    { value: 60, label: '开发商未缴费用数据导出' },
    { value: 61, label: '今年陈欠清缴账单数据导出' },
    { value: 62, label: '导出工单PDF打印版_有图' },
    { value: 63, label: '导出工单PDF打印版_无图' },
    { value: 64, label: '巡更导出_PDF打印版_有图' },
    { value: 65, label: '巡更导出_PDF打印版_无图' },
    { value: 66, label: '收款金额导出' },
    { value: 67, label: '退款金额/方式导出' },
    { value: 68, label: '收款金额导出' },
    { value: 69, label: '考勤统计数据导出' },
    { value: 83, label: '房屋未缴费用明细数据导出' },
    { value: 84, label: '车位未缴费用明细数据导出' },
    { value: 88, label: '合同-收款计划数据导出' },
    { value: 89, label: '合同-收款记录导出' },
    { value: 90, label: '合同-收款记录明细导出' },
    { value: 91, label: '租赁管理-应收金额导出' },
    { value: 92, label: '租赁管理-优惠金额导出' },
    { value: 93, label: '租赁管理-收款金额导出' },
    { value: 94, label: '租赁管理-退款金额导出' },
    { value: 95, label: '租赁管理-欠费金额导出' },
    { value: 96, label: '未缴账单-房屋未缴导入' },
    { value: 97, label: '未缴账单-车位未缴导入' },
    { value: 101, label: '个人住户导入Excel数据' },
    { value: 102, label: '公司住户导入Excel数据' },
    { value: 103, label: '全部账单数据导出' },
    { value: 108, label: '代扣管理费用导出' },
    { value: 109, label: '代扣管理账单导出' },
    { value: 110, label: '应收报表(按自然月统计)-应收金额导出' },
    { value: 111, label: '应收报表(按自然月统计)-优惠金额导出' },
    { value: 112, label: '应收报表(按自然月统计)-收款金额导出' },
    { value: 113, label: '应收报表(按自然月统计)-退款金额导出' },
    { value: 114, label: '应收报表(按自然月统计)-欠费金额导出' },
    { value: 115, label: '收款报表(按自然月统计)-收款金额导出' },
    { value: 116, label: '物资名称导入' },
    { value: 117, label: '物资分类导入' },
    { value: 118, label: '物资导入' },
    { value: 119, label: '财务收支记录导入' },
    { value: 120, label: '财务收支记录导出' },
    { value: 121, label: '商务租赁未缴统计费用数据导出' },
    { value: 122, label: '商务租赁未缴费用明细数据导出' },
    { value: 123, label: '学生信息导出' },
    { value: 124, label: '学生信息导入' },
    { value: 125, label: '调寝导入' },
    { value: 126, label: '进出寝记录导出' },
    { value: 127, label: '清空房屋关联计费导入' },
    { value: 128, label: '清空车位关联计费导入' },
    { value: 129, label: '学生归寝统计导出' },
    { value: 130, label: '学生归寝情况导出' },
    { value: 131, label: '访客记录导出' },
    { value: 132, label: '租赁一次性费用导入' },
    { value: 133, label: '数电票-蓝票导出' },
    { value: 134, label: '数电票-红票导出' },
    { value: 141, label: '财务管理-房屋押金导入' },
    { value: 142, label: '财务管理-房屋预存导入' },
    { value: 143, label: '财务管理-房屋已缴账单导入' },
    { value: 144, label: '财务管理-车位押金导入' },
    { value: 145, label: '财务管理-车位预存导入"' },
    { value: 146, label: '财务管理-车位已缴账单导入' },
  ],
  Months: [
    {
      value: 1,
      label: '1月份',
    },
    {
      value: 2,
      label: '2月份',
    },
    {
      value: 3,
      label: '3月份',
    },
    {
      value: 4,
      label: '4月份',
    },
    {
      value: 5,
      label: '5月份',
    },
    {
      value: 6,
      label: '6月份',
    },
    {
      value: 7,
      label: '7月份',
    },
    {
      value: 8,
      label: '8月份',
    },
    {
      value: 9,
      label: '9月份',
    },
    {
      value: 10,
      label: '10月份',
    },
    {
      value: 11,
      label: '11月份',
    },
    {
      value: 12,
      label: '12月份',
    },
  ],
  Quarters: [
    {
      value: 1,
      label: '第一季度(1-3月)',
    },
    {
      value: 2,
      label: '第二季度(4-6月)',
    },
    {
      value: 3,
      label: '第三季度(7-9月)',
    },
    {
      value: 4,
      label: '第四季度(10-12月)',
    },
  ],
  HalfYear: [
    {
      value: 1,
      label: '上半年(1-6月)',
    },
    {
      value: 2,
      label: '下半年(7-12月)',
    },
  ],
  Years: [
    {
      value: 1,
      label: '全年(1-12月)',
    },
  ],
  Periods: [
    {
      value: 1,
      label: '月度',
    },
    {
      value: 2,
      label: '季度',
    },
    {
      value: 3,
      label: '半年',
    },
    {
      value: 4,
      label: '年度',
    },
  ],
  // 入库状态
  StockStatus: [
    {
      value: 1,
      label: '待入库',
    },
    {
      value: 2,
      label: '已入库',
    },
  ],
  //出库状态
  DispatchStatus: [
    {
      value: 1,
      label: '待出库',
    },
    {
      value: 2,
      label: '已出库',
    },
  ],
  //采购申请状态

  PurchaseReqStatus: [
    {
      value: 1,
      label: '待审核',
    },
    {
      value: 2,
      label: '审核中',
    },
    {
      value: 3,
      label: '已通过',
    },
    {
      value: 4,
      label: '已驳回',
    },
  ],
  //采购计划状态
  PurchasePlanStatus: [
    {
      value: 3,
      label: '待采购',
    },
    {
      value: 5,
      label: '已采购',
    },
  ],
  //添加人员学历字段
  degreeStatus: [
    {
      value: 1,
      label: '小学以下',
    },
    {
      value: 2,
      label: '小学',
    },
    {
      value: 3,
      label: '初中',
    },
    {
      value: 4,
      label: '高中',
    },
    {
      value: 5,
      label: '专科',
    },
    {
      value: 6,
      label: '本科',
    },
    {
      value: 7,
      label: '硕士',
    },
    {
      value: 8,
      label: '博士',
    },
  ],
  //添加人员紧急联系人双方关系字段
  emergencyContactRelationshipStatus: [
    {
      value: 1,
      label: '父亲',
    },
    {
      value: 2,
      label: '母亲',
    },
    {
      value: 3,
      label: '朋友',
    },
    {
      value: 4,
      label: '配偶',
    },
    {
      value: 5,
      label: '亲人',
    },
  ],
  statusType: [
    {
      value: 1,
      label: '试用期',
    },
  ],
  dimissionReasonStatus: [
    {
      value: 1,
      label: '个人原因',
    },
    {
      value: 2,
      label: '公司辞退',
    },
    {
      value: 3,
      label: '试用期不合格',
    },
  ],
  //植物种类
  FloraTypeStatus: [
    {
      value: 1,
      label: '树木',
    },
    {
      value: 2,
      label: '花卉',
    },
    {
      value: 3,
      label: '地被植物',
    },
    {
      value: 4,
      label: '水生植物',
    },
    {
      value: 5,
      label: '果蔬',
    },
    {
      value: 6,
      label: '特殊植物',
    },
    {
      value: 7,
      label: '其他',
    },
  ],
  planSpeciesStatus: [
    {
      value: 1,
      label: '浇水',
    },
    {
      value: 2,
      label: '施肥',
    },
    {
      value: 3,
      label: '修剪',
    },
    {
      value: 4,
      label: '病虫害防治',
    },
    {
      value: 5,
      label: '综合',
    },
  ],
  ethnicList: [
    {
      value: 1,
      label: '汉族',
    },
    {
      value: 2,
      label: '蒙古族',
    },
    {
      value: 3,
      label: '回族',
    },
    {
      value: 4,
      label: '藏族',
    },
    {
      value: 5,
      label: '维吾尔族',
    },
    {
      value: 6,
      label: '苗族',
    },
    {
      value: 7,
      label: '彝族',
    },
    {
      value: 8,
      label: '壮族',
    },
    {
      value: 9,
      label: '布依族',
    },
    {
      value: 10,
      label: '朝鲜族',
    },
    {
      value: 11,
      label: '满族',
    },
    {
      value: 12,
      label: '侗族',
    },
    {
      value: 13,
      label: '瑶族',
    },
    {
      value: 14,
      label: '白族',
    },
    {
      value: 15,
      label: '土家族',
    },
    {
      value: 16,
      label: '哈尼族',
    },
    {
      value: 17,
      label: '哈萨克族',
    },
    {
      value: 18,
      label: '傣族',
    },
    {
      value: 19,
      label: '黎族',
    },
    {
      value: 20,
      label: '傈僳族',
    },
    {
      value: 21,
      label: '佤族',
    },
    {
      value: 22,
      label: '畲族',
    },
    {
      value: 23,
      label: '高山族',
    },
    {
      value: 24,
      label: '拉祜族',
    },
    {
      value: 25,
      label: '水族',
    },
    {
      value: 26,
      label: '东乡族',
    },
    {
      value: 27,
      label: '纳西族',
    },
    {
      value: 28,
      label: '景颇族',
    },
    {
      value: 29,
      label: '柯尔克孜族',
    },
    {
      value: 30,
      label: '土族',
    },
    {
      value: 31,
      label: '达斡尔族',
    },
    {
      value: 32,
      label: '仫佬族',
    },
    {
      value: 33,
      label: '羌族',
    },
    {
      value: 34,
      label: '布朗族',
    },
    {
      value: 35,
      label: '撒拉族',
    },
    {
      value: 36,
      label: '毛难族',
    },
    {
      value: 37,
      label: '仡佬族',
    },
    {
      value: 38,
      label: '锡伯族',
    },
    {
      value: 39,
      label: '阿昌族',
    },
    {
      value: 40,
      label: '普米族',
    },
    {
      value: 41,
      label: '塔吉克族',
    },
    {
      value: 42,
      label: '怒族',
    },
    {
      value: 43,
      label: '乌孜别克族',
    },
    {
      value: 44,
      label: '俄罗斯族',
    },
    {
      value: 45,
      label: '鄂温克族',
    },
    {
      value: 46,
      label: '崩龙族',
    },
    {
      value: 47,
      label: '保安族',
    },
    {
      value: 48,
      label: '裕固族',
    },
    {
      value: 49,
      label: '京族',
    },
    {
      value: 50,
      label: '塔塔尔族',
    },
    {
      value: 51,
      label: '独龙族',
    },
    {
      value: 52,
      label: '鄂伦春族',
    },
    {
      value: 53,
      label: '赫哲族',
    },
    {
      value: 54,
      label: '门巴族',
    },
    {
      value: 55,
      label: '珞巴族',
    },
    {
      value: 56,
      label: '基诺族',
    },
    {
      value: 57,
      label: '其他',
    },
    {
      value: 58,
      label: '外国血统中国籍人士',
    },
  ],
  maritalStatusList: [
    {
      value: 10,
      label: '未婚',
    },
    {
      value: 20,
      label: '已婚',
    },
    {
      value: 30,
      label: '丧偶',
    },
    {
      value: 40,
      label: '离婚',
    },
  ],
  politicalOutlookList: [
    {
      value: 1,
      label: '中共党员',
    },
    {
      value: 2,
      label: '中共预备党员',
    },
    {
      value: 3,
      label: '共青团员',
    },
    {
      value: 13,
      label: '群众',
    },
    {
      value: 4,
      label: '民革会员',
    },
    {
      value: 5,
      label: '民盟盟员',
    },
    {
      value: 6,
      label: '民建会员',
    },
    {
      value: 7,
      label: '民进会员',
    },
    {
      value: 8,
      label: '农工党党员',
    },
    {
      value: 9,
      label: '致公党党员',
    },
    {
      value: 10,
      label: '九三学社社员',
    },
    {
      value: 11,
      label: '台盟盟员',
    },
    {
      value: 12,
      label: '无党派民主人士',
    },
  ],
  externalPersonnelList: [
    {
      value: 1,
      label: '全职',
    },
    {
      value: 2,
      label: '兼职',
    },
    {
      value: 3,
      label: '外派人员',
    },
    {
      value: 4,
      label: '外包人员',
    },
    {
      value: 5,
      label: '外部人员',
    },
  ],
  statusTypeList: [
    {
      value: 1,
      label: '正式',
    },
    {
      value: 2,
      label: '试用',
    },
    {
      value: 3,
      label: '实习',
    },
  ],
  certList: [
    {
      value: 1,
      label: '项目经理证',
    },
    {
      value: 2,
      label: '消防安全员证',
    },
    {
      value: 3,
      label: '物业维修工证',
    },
    {
      value: 4,
      label: '园林绿化证',
    },
    {
      value: 5,
      label: '电工职业资格证',
    },
  ],
  contractTypeList: [
    {
      value: 1,
      label: '固定期限劳动合同',
    },
    {
      value: 2,
      label: '无固定期限劳动合同',
    },
    {
      value: 3,
      label: '实习协议',
    },
    {
      value: 4,
      label: '劳务协议',
    },
    {
      value: 5,
      label: '劳务派遣合同',
    },
    {
      value: 6,
      label: '返聘协议',
    },
    {
      value: 7,
      label: '短期劳动合同',
    },
    {
      value: 8,
      label: '其他合同',
    },
  ],
  difficultyStatus: [
    {
      value: 1,
      label: '简单',
    },
    {
      value: 2,
      label: '一般',
    },
    {
      value: 3,
      label: '困难',
    },
  ],
  staffStatusStatus: [
    {
      value: 1,
      label: '请假中',
    },
    {
      value: 2,
      label: '出差中',
    },
    {
      value: 3,
      label: '休息中',
    },
  ],
  departmentTypeStatus: [
    {
      value: 1,
      label: '公司',
    },
    {
      value: 2,
      label: '项目',
    },
    {
      value: 3,
      label: '专业部门',
    },
  ],
  BuildingRoomChanceTypeEnum: [
    {
      value: 1,
      label: '合并',
    },
    {
      value: 2,
      label: '拆分',
    },
    {
      value: 3,
      label: '调整面积',
    },
    {
      value: 4,
      label: '状态变更',
    },
    {
      value: 5,
      label: '财务交割',
    },
    {
      value: 6,
      label: '调整位置',
    },
    {
      value: 7,
      label: '删除',
    },
    {
      value: 8,
      label: '收费标准变更',
    },
    {
      value: 9,
      label: '收费标准绑定',
    },
    {
      value: 10,
      label: '收费标准解绑',
    },
  ],
  versioningStatus: [
    {
      value: 1,
      label: '审核中',
    },
    {
      value: 2,
      label: '通过',
    },
    {
      value: 3,
      label: '拒绝',
    },
    {
      value: 4,
      label: '撤销',
    },
  ],
  adminMessageEnumArr: [
    // 消息类型
    { value: 0, label: '工单待处理' },
    { value: 1, label: '工单待派单', path: '/workOrder/workOrderLIst', message: '您有一条工单待派单！' },
    { value: 2, label: '住户认证待审核', path: '/householdManage/householdCheck', message: '你有一条住户认证待审核！' },
    { value: 3, label: '物资申领待审批', path: '/materialManage/getGoods', message: '您有一条物资申领待审批！' },
    { value: 4, label: '退款待审批', path: '/approvalCenter/refundApproval', message: '你有一条退款申请待审批！' },
    { value: 5, label: '工单收到差评', path: '/workOrder/evaluate', message: '您有一条工单差评待处理！' },
    { value: 6, label: '设备待巡检' },
    { value: 7, label: '路线待巡更' },
    { value: 8, label: '监控报警', path: '/IOTManage/monitoringAlarm', message: '你有一条监控报警待处理！' },
    { value: 9, label: '请假申请待审批', path: '/approvalCenter/leaveApproval', message: '您有一条请假申请待审批！' },
    { value: 10, label: '出差申请待审批', path: '/approvalCenter/travelApproval', message: '您有一条出差申请待审批！' },
    { value: 11, label: '报销申请待审批', path: '/approvalCenter/reimbursementApproval', message: '您有一条报销申请待审批！' },
    { value: 12, label: '物资申领抄送', path: '/materialManage/getGoods', message: '您有一条物资申领抄送待查看！' },
    { value: 13, label: '请假审批抄送', path: '/approvalCenter/leaveApproval', message: '您有一条请假申请抄送待查看！' },
    { value: 14, label: '出差审批抄送', path: '/approvalCenter/travelApproval', message: '您有一条出差申请抄送待查看！' },
    { value: 15, label: '报销审批抄送', path: '/approvalCenter/reimbursementApproval', message: '您有一条报销申请抄送待查看！' },
    { value: 17, label: '优惠申请待审批', path: '/approvalCenter/discountApplication', message: '您有一条优惠申请待审批！' },
    { value: 18, label: '优惠申请通过', path: '/business/business', message: '您有一条优惠申请已通过！' },
    { value: 19, label: '优惠申请驳回', path: '/business/business', message: '您有一条优惠申请被驳回！' },
    { value: 20, label: '优惠申请抄送', path: '/approvalCenter/discountApplication', message: '您有一条优惠申请抄送待查看！' },
    { value: 21, label: '住户认证审核通过', path: '/householdManage/householdCheck', message: '您有一条住户认证审核已通过！' },
    { value: 22, label: '退款申请通过', path: '/finance/refundLog', message: '您有一条退款申请已通过！' },
    { value: 23, label: '退款申请驳回', path: '/approvalCenter/refundApproval', message: '您有一条退款申请被驳回！' },
    { value: 24, label: '退款申请抄送', path: '/approvalCenter/refundApproval', message: '您有一条退款申请抄送待查看！' },
    { value: 25, label: '内部通知文章发布', path: '/workManage/internalNotification', message: '您有一条内部通知文章待查看！' },
    { value: 26, label: '工单已完成', path: '', message: '' },
    { value: 27, label: '用章申请待审批', path: '/approvalCenter/approvalWithSeal', message: '您有一条用章申请待审批！' },
    { value: 28, label: '用章申请驳回', path: '/approvalCenter/approvalWithSeal', message: '您有一条用章申请审批被驳回！' },
    { value: 29, label: '用章申请通过', path: '/approvalCenter/approvalWithSeal', message: '您有一条用章申请已通过！' },
    { value: 30, label: '考勤', path: '', message: '' },
    { value: 31, label: '装修申请待审批', path: '/decorationManagement/decorationApplication', message: '您有一条装修申请待审批！' },
    { value: 32, label: '物资借用申请待审批', path: '/materialManage/materialBorrow', message: '您有一条物资借用申请待审批！' },
    { value: 35, label: '合同管理', path: '/contractManagement/contractManagement', message: '您有一份合同即将到期！' },
    { value: 36, label: '采购申请', path: '/approvalCenter/PurchaseReq', message: '您有一条采购申请待审批！' },
    { value: 37, label: '采购申请通过', path: '/Procurement/purchaseRequest', message: '您有一条采购申请已通过！' },
    { value: 38, label: '采购申请驳回', path: '/approvalCenter/PurchaseReq', message: '您有一条采购申请被驳回！' },
    { value: 39, label: '采购申请抄送', path: '/approvalCenter/PurchaseReq', message: '您有一条采购申请抄送待查看！' },
    { value: 40, label: '物资申领驳回', path: '/materialManage/getGoods', message: '您有一条物资申领被驳回！' },
    { value: 41, label: '采购申请完成采购', path: '/materialManage/ReceiptForm', message: '您有一条采购申请已完成采购，请确认入库！' },
    { value: 42, label: '设备待维保', path: '/materialManage/ReceiptForm', message: '您有一个设备待维保！' },
    { value: 45, label: '补卡申请通过', path: '/approvalCenter/RepunchApproval', message: '您有一条补卡申请已通过！' },
    { value: 46, label: '补卡申请驳回', path: '/approvalCenter/RepunchApproval', message: '您有一条补卡申请被驳回！' },
    { value: 47, label: '补卡申请抄送', path: '/approvalCenter/RepunchApproval', message: '您有一条补卡申请抄送待查看！' },
    { value: 48, label: '补卡申请', path: '/approvalCenter/RepunchApproval', message: '您有一条补卡申请待审批！' },

    // { value: 33, label: '物资借用申请通过', path: '/materialManage/materialBorrow', message: '您有一条物资借用申请已通过！' },
    // { value: 34, label: '物资借用申请驳回', path: '/materialManage/materialBorrow', message: '您有一条物资借用申请被驳回！' },
    { value: 49, label: '优惠申请驳回', path: '/contractPayment/contractPayment', message: '您有一条优惠申请被驳回！' },
    { value: 50, label: '优惠申请通过', path: '/contractPayment/contractPayment', message: '您有一条优惠申请已通过！' },
    { value: 51, label: '退款申请驳回', path: '/leaseManagement/RefundHistory', message: '您有一条退款申请被驳回！' },
    { value: 52, label: '退款申请通过', path: '/leaseManagement/RefundHistory', message: '您有一条退款申请已通过！' },
    { value: 53, label: '优惠申请待审批', path: '/leaseManagement/DiscountApproval', message: '您有一条优惠申请待审批！' },
    { value: 54, label: '优惠申请抄送', path: '/leaseManagement/DiscountApproval', message: '您有一条优惠申请抄送待查看！' },
    { value: 55, label: '退款申请待审批', path: '/leaseManagement/RefundRequestForm', message: '您有一条退款申请待审批！' },
    { value: 56, label: '退款申请抄送', path: '/leaseManagement/RefundRequestForm', message: '您有一条退款申请抄送待查看！' },
    { value: 57, label: '租赁合同到期提醒', path: '/leaseManagement/leaseAgreement', message: '您有一个租赁合同即将到期！' },
    { value: 58, label: '招商线索提醒', path: '/investmentManagement/investmentLeads', message: '您有一条新的招商线索待处理！' },
    { value: 62, label: '设备报警提醒', path: '/equipment/alertrecord', message: '您有一条新的设备报警待查看！' },
    { value: 61, label: '投诉处理提醒', path: '/complaintManagement/complaintRecord', message: '您有一条投诉待处理！' },
    { value: 63, label: '财务作废申请', path: '/approvalCenter/VoidApproval', message: '您有一条财务作废待审批！' },
    { value: 64, label: '财务作废抄送', path: '/approvalCenter/VoidApproval', message: '您有一条财务作废抄送待查看！' },
    { value: 65, label: '财务作废驳回', path: '/approvalCenter/VoidApproval', message: '您有一条财务作废被驳回！' },
    { value: 66, label: '财务作废通过', path: '/approvalCenter/VoidApproval', message: '您有一条财务作废已通过！' },
  ],
}
